class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this), {passive: true});
        this.addEventListener('focusout', this.onFocusOut.bind(this), {passive: true});
        this.bindEvents();
        const menu_drawer = document.getElementById('menu-drawer')
        const bottom_nav = document.getElementById('mobile_nav')
        const top_nav = document.querySelector('header.ml_header')
        if (bottom_nav) {
            const height = bottom_nav.clientHeight + (top_nav?.clientHeight || 0)
            if (menu_drawer) {
                menu_drawer.style.height = `calc(100vh - ${height}px)`
            }
        }
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this), {passive: true}));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement?.hasAttribute('open');
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus, {passive: true});
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
            document.body.style.overflowY = 'hidden'
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        document.body.style.overflowY = ''
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle?.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
        this.elements = {
            toggler: this.querySelector("#ml_menu_drawer_main_toggler"),
            content: this.querySelector("#ml_menu_drawer_main_content"),
        }

        // Create overlay element inside the header-drawer (not body)
        this._overlay = document.createElement('div');
        this._overlay.id = 'gh-menu-overlay';
        this._overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:2147483639;';
        this.appendChild(this._overlay);

        const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');

        // Close button
        var closeBtn = this.querySelector("#ml_menu_drawer_close");
        if (closeBtn) {
            closeBtn.addEventListener("click", () => this._closeDrawer(), {passive: true});
        }

        this.elements?.toggler?.addEventListener("click", () => {
            var isOpening = !this.elements?.content?.classList.contains("ml_menu_drawer__open");

            if (isOpening) {
                var headerH = header ? (header.offsetHeight + header.offsetTop) : 0;
                this.elements.content.style.paddingTop = headerH + 'px';
                document.body.style.overflow = "hidden";
                this._overlay.style.display = "block";
            } else {
                this._closeDrawer();
                return;
            }

            this.elements?.toggler?.classList.add("ml_menu_drawer__open");
            this.elements?.content?.classList.add("ml_menu_drawer__open");
        }, {passive: true})

        // Close on overlay click
        this._overlay.addEventListener("click", () => this._closeDrawer(), {passive: true});
    }

    _closeDrawer() {
        this.elements?.toggler?.classList.remove("ml_menu_drawer__open");
        this.elements?.content?.classList.remove("ml_menu_drawer__open");
        document.body.style.overflow = "auto";
        this._overlay.style.display = "none";
    }
}

customElements.define('header-drawer', HeaderDrawer);
class HeaderSubMenu extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            toggler: this.querySelector(".ml_menu_drawer__sub_menu_container_toggle"),
            content: this.querySelector(".ml_menu_drawer__sub_menu_container_content")
        }

        // ml_menu_drawer_main_content
        const draweMenu = document.body.querySelector("#ml_menu_drawer_main_content");
        this.elements?.toggler?.addEventListener("click", debounce(() => {
            if (!this.elements?.content?.classList.contains("ml_menu_drawer__open")) {
                this.elements?.toggler?.classList.toggle("ml_menu_drawer__open");
                if (this.elements.content) {
                    this.elements.content.style.position = "absolute";
                    this.elements.content.style.height = "auto";
                }
                const height = this.elements?.content.clientHeight;
                setTimeout(() => {
                    this.elements.content.style.height = "0";
                    this.elements.content.style.position = "relative";
                })
                setTimeout(() => {
                    if (this.elements.content) {
                        this.elements.content.style.height = `${height}px`;
                    }
                    this.elements?.content?.classList.toggle("ml_menu_drawer__open");
                    setTimeout(() => {
                        this.elements.content.style.height = "";
                    }, 500)
                }, 50)
            } else {
                const height = this.elements?.content.clientHeight;
                if (this.elements.content) {
                    this.elements.content.style.height = `${height}px`;
                }

                this.elements?.toggler?.classList.toggle("ml_menu_drawer__open");
                setTimeout(() => {
                    if (this.elements.content) {
                        this.elements.content.style.height = "0";
                    }
                    this.elements?.content?.classList.toggle("ml_menu_drawer__open");
                }, 50);
            }
        }, 50), {passive: true})
    }
}

customElements.define('header-sub-menu', HeaderSubMenu);